'use strict';

/**
 * Converts a string to uppercase.
 *
 * @param {String} s The string.
 * @returns {String} A new string.
 * @example
 *
 * import { toUpper } from 'fkit'
 * toUpper('foo') // FOO
 */
function toUpper(s) {
  return s.toUpperCase();
}

module.exports = toUpper;
